import React, { useEffect, useRef, useState } from "react";
import { getCutlist, getCutlistProducts } from "../product/service";
import { useNavigate, useParams } from "react-router-dom";
import {
  CLPButton,
  CLPImage,
  CLPLabel,
  CoreContainer,
  Icon,
  Notification,
  InfoContainer,
} from "./style";
import Select from "react-select";
import { Button, Col, Input, Label, Spinner, Table } from "reactstrap";
import { ExpoIcon } from "../project/style";
import { OptionImage } from "../product/style";
import { EXPO_PROPERTY_CONSTANTS } from "../constants";
import { toLower } from "lodash";
import { MobileCutlist } from "../carpenter-view";

const CutlistPromo = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [product, setProduct] = useState(null);
  const [cutlists, setCutlists] = useState([]);
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [notificationMessage, setNotificationMessage] = useState({});
  const [enableCutlist, setEnableCutlist] = useState(false);
  const [expoOptions, setExpoOptions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState("");

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  useEffect(() => {
    setIsLoading(true);
    getCutlistProducts()
      .then((products) => {
        setProducts(products);
        const currentProduct = products[0];
        setProduct(currentProduct);
        fetchCutlist(currentProduct);
        setImageUrl(currentProduct.images[0]);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "error", message: error });
      })
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    if (products.length === 0) return;
    const currentProduct = products.find(
      (product) => product.id == params.productId
    );
    setProduct(currentProduct);
    fetchCutlist(currentProduct);
    setImageUrl(currentProduct.images[0]);
  }, [params]);

  const fetchCutlist = (agrsProduct) => {
    const selectedProduct = agrsProduct ? agrsProduct : product;
    const dimensions = selectedProduct.dimensions;
    const min_dimensions = selectedProduct.min_dimensions;
    const max_dimensions = selectedProduct.max_dimensions;

    if (
      !(
        parseInt(min_dimensions.height) <= parseInt(dimensions.height) &&
        parseInt(dimensions.height) <= parseInt(max_dimensions.height) &&
        parseInt(min_dimensions.width) <= parseInt(dimensions.width) &&
        parseInt(dimensions.width) <= parseInt(max_dimensions.width) &&
        parseInt(min_dimensions.depth) <= parseInt(dimensions.depth) &&
        parseInt(dimensions.depth) <= parseInt(max_dimensions.depth)
      )
    ) {
      setIsNotificationVisible(true);
      setNotificationMessage({
        type: "error",

        message: (
          <div>
            <p className="m-0">
              {min_dimensions.height} &lt; Height &lt; {max_dimensions.height}
            </p>
            <p className="m-0">
              {min_dimensions.width} &lt; Width &lt; {max_dimensions.width}
            </p>
            <p className="m-0">
              {min_dimensions.depth} &lt; Depth &lt; {max_dimensions.depth}
            </p>
          </div>
        ),
      });

      return;
    }
    setIsLoading(true);
    const exposedSides = selectedProduct.expo_sides.map(toLower);
    const exposedSidesPayload = selectedProduct.has_exposed_sides
      ? Object.keys(EXPO_PROPERTY_CONSTANTS).reduce((accumulator, value) => {
          accumulator[`exposed_side_${value}`] = exposedSides.includes(value)
            ? EXPO_PROPERTY_CONSTANTS[value][0]
            : EXPO_PROPERTY_CONSTANTS[value][1];

          return accumulator;
        }, {})
      : {};
    setEnableCutlist(false);
    getCutlist({
      productId: selectedProduct.id,
      options: { ...selectedProduct.dimensions, ...exposedSidesPayload },
    })
      .then((cutlist) => {
        setCutlists(Object.values(cutlist).flat());
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "error", message: error });
      })
      .finally(() => setIsLoading(false));
  };

  const changeImage = (url) => {
    if (product.images.length === 1) return;
    const index = product.images.indexOf(url);
    index === 0
      ? setImageUrl(product.images[1])
      : setImageUrl(product.images[0]);
  };

  const colorChange = () => {
    setIsNotificationVisible(true);
    setNotificationMessage({
      type: "error",
      message: "To customize color, please create a account",
    });
  };

  const previousProduct = () => {
    const newIndex = products.indexOf(product) - 1;
    const newProductId =
      newIndex > -1 ? products[newIndex].id : products[products.length - 1].id;
    navigate(`/cl/${newProductId}`);
  };

  const nextProduct = () => {
    const newIndex = products.indexOf(product) + 1;
    const newProductId =
      newIndex === products.length ? products[0].id : products[newIndex].id;
    navigate(`/cl/${newProductId}`);
  };

  const handleDimensionsChange = (dimension, value) => {
    const updatedDimensions = {
      ...product.dimensions,
      [dimension]: value,
    };
    setProduct((prevProduct) => ({
      ...prevProduct,
      dimensions: updatedDimensions,
    }));
    setEnableCutlist(true);
  };

  const handleExpoChange = (selectedOptions) => {
    const updatedExpoSides = Array.from(
      selectedOptions,
      (option) => option.value
    );
    setProduct((prevProduct) => ({
      ...prevProduct,
      expo_sides: updatedExpoSides,
    }));
    setEnableCutlist(true);
  };

  const [copied, setCopied] = useState(false);

  const tableRef = useRef(null);
  const [copiedContent, setCopiedContent] = useState("");

  const copyTableData = () => {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(tableRef.current);
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand("copy");
    selection.removeAllRanges();
    setCopiedContent(window.getSelection().toString());
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  const shutterColorOptions = [
    {
      name: "Acemica Brown Paper 4145-A-155 Pista Grey",
      image:
        "https://zenterior-uploads.s3.amazonaws.com/uploads/laminate/sample_image/1544/4145.jpg",
    },
    {
      name: "Acrylam Cappucino with Factory Charge New",
      image:
        "https://zenterior-uploads.s3.amazonaws.com/uploads/laminate/sample_image/1118/165074CappuccinoVM_1103_Capuccino_high.jpg",
    },

    {
      name: "Airolam 104 SF New",
      image:
        "https://zenterior-uploads.s3.amazonaws.com/uploads/laminate/sample_image/964/99987.jpg",
    },

    {
      name: "Century 109 LU Designer White",
      image:
        "https://zenterior-uploads.s3.amazonaws.com/uploads/laminate/sample_image/1256/Century_laminates_-Designer_white_109_LU.JPG",
    },

    {
      name: "Greenlam 107 HGL Wool",
      image:
        "https://zenterior-uploads.s3.amazonaws.com/uploads/laminate/sample_image/1289/gsb-107-wool_33.jpg",
    },

    {
      name: "Hettich Profile door Grant Neo 3 Door ",
      image:
        "https://zenterior-uploads.s3.amazonaws.com/uploads/laminate/sample_image/1578/Grant_neo_profile_lacqured.png",
    },

    {
      name: "Merino 27107 Umber Luvih",
      image:
        "https://zenterior-uploads.s3.amazonaws.com/uploads/laminate/sample_image/1467/27107.jpg",
    },
  ];

  return (
    <>
      {isLoading ? (
        <CoreContainer>
          <Spinner>Loading...</Spinner>
        </CoreContainer>
      ) : (
        product && (
          <div>
            <InfoContainer className="pt-4 px-3 px-sm-5">
              {notificationMessage.type && (
                <Notification
                  color={
                    notificationMessage.type === "error" ? "danger" : "success"
                  }
                  isOpen={isNotificationVisible}
                  toggle={onDismissNotification}
                >
                  {notificationMessage.message}
                </Notification>
              )}
              <div className="row">
                <div className="col-2 d-flex justify-content-center align-items-center">
                  <Icon
                    size="30px"
                    className="fa-solid fa-chevron-left pointer"
                    onClick={() => previousProduct()}
                  />
                </div>
                <div className="col-8 d-flex flex-column justify-content-center align-items-center">
                  <CLPImage
                    src={imageUrl}
                    onClick={() => changeImage(imageUrl)}
                  />
                </div>
                <div className="col-2 d-flex justify-content-center align-items-center">
                  <Icon
                    size="30px"
                    className="fa-solid fa-chevron-right pointer"
                    onClick={() => nextProduct()}
                  />
                </div>
              </div>
              <h2 className="mt-4 text-center">{product.name}</h2>
              <div className="row mt-4">
                <div className="ps-0 col-3">
                  <CLPLabel>Height</CLPLabel>
                  <Input
                    type="number"
                    pattern="[0-9]*"
                    inputMode="numeric"
                    onChange={(e) =>
                      handleDimensionsChange("height", e.target.value)
                    }
                    value={product.dimensions.height}
                  />
                </div>
                <div className="col-3">
                  <CLPLabel>Width</CLPLabel>
                  <Input
                    type="number"
                    pattern="[0-9]*"
                    inputMode="numeric"
                    onChange={(e) =>
                      handleDimensionsChange("width", e.target.value)
                    }
                    value={product.dimensions.width}
                  />
                </div>
                <div className="col-3">
                  <CLPLabel>Depth</CLPLabel>
                  <Input
                    type="number"
                    pattern="[0-9]*"
                    inputMode="numeric"
                    onChange={(e) =>
                      handleDimensionsChange("depth", e.target.value)
                    }
                    value={product.dimensions.depth}
                  />
                </div>
                {product.has_exposed_sides && (
                  <div className="col-3 pe-0">
                    <CLPLabel>Expo</CLPLabel>
                    <Label for="expoMultiSelect" className="ps-0" sm={2}>
                      <React.Fragment>
                        <ExpoIcon
                          onClick={() => setExpoOptions(true)}
                          className={product.expo_sides
                            .filter(Boolean)
                            .join(" ")}
                        >
                          E
                        </ExpoIcon>
                      </React.Fragment>
                    </Label>
                    {expoOptions && (
                      <Col md={12} className="ps-0 position-absolute">
                        <Input
                          id="expoMultiSelect"
                          multiple
                          name="expoMultiSelect"
                          type="select"
                          value={product.expo_sides}
                          onChange={(e) => {
                            handleExpoChange(e.target.selectedOptions);
                          }}
                          onBlur={() => setExpoOptions(false)}
                        >
                          {Object.keys(EXPO_PROPERTY_CONSTANTS).map(
                            (side, index) => {
                              return (
                                <option
                                  value={
                                    side.charAt(0).toUpperCase() + side.slice(1)
                                  }
                                  key={index}
                                >
                                  {side.charAt(0).toUpperCase() + side.slice(1)}
                                </option>
                              );
                            }
                          )}
                        </Input>
                      </Col>
                    )}
                  </div>
                )}
              </div>
              <div className="row mt-3 p-0">
                <CLPLabel>Shutter Color</CLPLabel>
                <div className="d-flex justify-content-between align-items-center p-0">
                  <Select
                    value={shutterColorOptions.find(
                      (option) =>
                        option.name ===
                        "Acemica Brown Paper 4145-A-155 Pista Grey"
                    )}
                    onChange={() => colorChange()}
                    className="col-7"
                    options={shutterColorOptions.map((option, index) => {
                      option.value = option.name;
                      option.label = option.image ? (
                        <div key={index}>
                          {option.image && (
                            <OptionImage
                              key={index}
                              src={option.image}
                              alt={option.name}
                              className="me-2 border border-dark rounded-circle"
                            />
                          )}
                          {option.name}
                        </div>
                      ) : (
                        option.name
                      );

                      return {
                        ...option,
                      };
                    })}
                  />
                  <div className="col-2">
                    <Button
                      style={{ padding: "5px 10px" }}
                      disabled={!enableCutlist}
                      className="bg-success border-0"
                      onClick={() => fetchCutlist(null)}
                    >
                      Cutlist
                    </Button>
                  </div>
                  {copied ? (
                    <div className="col-2 d-flex align-items-center">
                      <i className="fa-solid fa-check me-2"></i>
                      <p className="m-0">Copied</p>
                    </div>
                  ) : (
                    <div
                      onClick={copyTableData}
                      className="col-2 d-flex align-items-center"
                    >
                      <i className="fa-regular fa-clipboard me-2"></i>
                      <p className="m-0">Copy</p>
                    </div>
                  )}
                </div>
              </div>
              <div className="overflow-hidden">
                <div style={{ height: "0px" }} className="opacity-0">
                  <Table innerRef={tableRef}>
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Name</th>
                        <th>Length1</th>
                        <th>Length2</th>
                        <th>Side 1</th>
                        <th>Side 2</th>
                        <th>Groove</th>
                        <th>Edge Config</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cutlists.map((cutlist, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{cutlist.name}</td>
                          <td>{cutlist.length_1}</td>
                          <td>{cutlist.length_2}</td>
                          <td>{cutlist.groove_config}</td>
                          <td>{cutlist.edge_config}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
                <div className="mt-3 mb-4 border border-2">
                  {cutlists &&
                    cutlists.map((e, index) => (
                      <MobileCutlist
                        showcolor={false}
                        key={index}
                        cutlist={e}
                        index={index}
                      />
                    ))}
                </div>
              </div>
            </InfoContainer>
            <div
              className="p-3 text-white position-fixed bottom-0 start-0 end-0"
              style={{ background: "#0c3157", zIndex: "2" }}
            >
              <h5 className="text-center">
                {" "}
                To customize color and view more catalogs
              </h5>
              <CLPButton onClick={() => navigate("/register")}>
                Sign Up
              </CLPButton>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default CutlistPromo;
